<template>
  <footer class="footer">
    <div class="container">
      <div class="footer-content">
        <!-- Logo y descripción -->
        <div class="footer-section">
          <img src="@/assets/zapiola-logo.png" alt="Zapiola Growshop" class="footer-logo img-fluid">
        </div>

        <!-- Links útiles -->
        <div class="footer-section">
          <h4 class="footer-subtitle">Enlaces Útiles</h4>
          <ul class="footer-links">
            <li><a class="fs-7" href="/productos">Productos</a></li>
            <li><a class="fs-7" href="/mi-cuenta">Cuenta</a></li>
            <li><a class="fs-7" href="https://instagram.com/zapiola_growshop" target="_blank">Contacto</a></li>
          </ul>
        </div>

        <!-- Contacto -->
        <div class="footer-section">
          <h4 class="footer-subtitle">Contacto</h4>
          <ul class="footer-contact">
            <li class="fs-7">
              <i class="fas fa-map-marker-alt"></i>
              <a href="https://maps.app.goo.gl/z7aF9hUx6fWLJE768" target="_blank" class="text-decoration-none text-white fw-light fs-7">
                Zapiola 661, Paso del Rey 1742
              </a>
            </li>
            <li class="fs-7">
              <i class="fab fas fa-instagram"></i>
              <a href="https://instagram.com/zapiolagrowshop" target="_blank" class="text-decoration-none text-white fw-light fs-7">
          @zapiolagrowshop
              </a>
            </li>
            <li class="fs-7">
              <i class="fas fa-envelope"></i>
              <a href="mailto:growshopzapiola@gmail.com" class="text-decoration-none text-white fw-light fs-7">
          growshopzapiola@gmail.com
              </a>
            </li>
          </ul>
        </div>

        <!-- Redes sociales -->
        <div class="footer-section">
          <h4 class="footer-subtitle">Síguenos</h4>
          <div class="social-links">
            <a href="https://instagram.com/zapiola_growshop" class="social-link"><i class="fab fa-instagram"></i></a>
            <a href="https://www.facebook.com/GrowShop.zapiola" class="social-link"><i class="fab fa-facebook"></i></a>
          </div>
        </div>
      </div>

      <div class="footer-bottom">
        <p class="fs-7">&copy; {{ currentYear }} Zapiola Growshop. Todos los derechos reservados.</p>
      </div>
      <div class="dev d-flex justify-content-center">
        <p class="fs-7">Desarrollado por <a href="https://permaculture.ar" target="_blank" class="text-decoration-none">
          <img src="@/assets/images/permaculture.svg" alt="Permaculture Logo" class="img-fluid" style="max-width: 130px; margin-top:11px;">
        </a></p>
      </div>
    </div>
  </footer>
</template>

<script setup>
const currentYear = new Date().getFullYear()
</script>

<style>
.footer {
  background-color: var(--black-color-2);
  color: var(--white-color-2);
  padding: 4rem 0 1rem 0;
  margin-top: 4rem;
}

.footer-logo {
  width: 150px;
  margin-bottom: 1rem;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
  gap: 2rem;
  margin-bottom: 3rem;
}

.footer-section {
  padding: 0 1rem;
}

.footer-title {
  color: var(--white-color);
  font-size: 1.2rem;
  margin-bottom: 1rem;
}

.footer-subtitle {
  color: var(--white-color);
  font-size: 1rem;
  margin-bottom: 1rem;
  font-weight: 500;
}

.footer-description {
  color: var(--white-color-2);
  line-height: 1.6;
}

.footer-links {
  list-style: none;
  padding: 0;
}

.footer-links li {
  margin-bottom: 0.5rem;
}

.footer-links a {
  color: var(--white-color-2);
  text-decoration: none;
  transition: color 0.3s ease;
}

.footer-links a:hover {
  color: var(--primary-color);
}

.footer-contact {
  list-style: none;
  padding: 0;
}

.footer-contact li {
  margin-bottom: 1rem;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.social-links {
  display: flex;
  gap: 1rem;
}

.social-link {
  color: var(--white-color-2);
  font-size: 1.5rem;
  transition: color 0.3s ease;
}

.social-link:hover {
  color: var(--primary-color);
}

.footer-bottom {
  border-top: 1px solid var(--black-color-3);
  padding-top: 1rem;
  text-align: center;
  color: var(--white-color-2);
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
    text-align: center;
  }

  .footer-contact li {
    justify-content: center;
  }

  .social-links {
    justify-content: center;
  }
}
</style>
